import { render, staticRenderFns } from "./itweb.vue?vue&type=template&id=eb3f164e"
import script from "./itweb.vue?vue&type=script&lang=js"
export * from "./itweb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports